import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { InsuranceType } from 'src/app/_enums/insurance-type.enum';

import { LeadFormBase } from '../lead-form-base';

@Component({
  selector: 'app-lead-benefits-account-form',
  templateUrl: './benefits-account-form.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class BenefitsAccountFormComponent extends LeadFormBase {
  @Input()
  formGroup!: FormGroup;

  constructor(private fb: FormBuilder) {
    super();
  }

  metadataFormGroup: FormGroup = this.fb.group({
    type: InsuranceType.BENEFITS_ACCOUNT,
  });

  override ngOnInit(): void {
    super.ngOnInit();
    this.formGroup.removeControl('metadata');
    if (this.metadata) this.metadataFormGroup.patchValue(this.metadata);
    this.formGroup.addControl('metadata', this.metadataFormGroup);
  }
}
